export default function NotFoundPage(){
    return(
        <div>
            <h1>ERROR 404</h1>
            <h3>Página no encontrada</h3>
        </div>
    );
}